import SchoolClassroom, {
  SchoolClassroomInput
} from '@/core/domain/school/classroom/SchoolClassroom.ts'
import SchoolPeriodUserMapper from '@/core/infrastructure/mappers/school/period/SchoolPeriodUserMapper.ts'
import type {
  SchoolClassroomInputEntity
} from '@/core/infrastructure/schemas/school/classroom/SchoolClassroomSchema.ts'

export class SchoolClassroomMapper {
  static toInput(classroom: SchoolClassroom): SchoolClassroomInput {
    const users = classroom.users.map((u) => SchoolPeriodUserMapper.toEntity(u))
    const input = {
      schoolClassroomId: classroom.schoolClassroomId,
      schoolPeriodId: classroom.schoolPeriodId,
      name: classroom.name,
      degree: classroom.degree,
      type: classroom.type,
      users: users
    } satisfies SchoolClassroomInputEntity
    return SchoolClassroomInput.create(input)
  }
}